import { render, staticRenderFns } from "./IntegrationsSettings.vue?vue&type=template&id=1fd30da6"
import script from "./IntegrationsSettings.vue?vue&type=script&lang=js"
export * from "./IntegrationsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports